import(/* webpackMode: "eager", webpackExports: ["HändelserView"] */ "/app/src/sections/presentation/handelser/handelser-view.tsx");
